export interface ProductNewFields {
  /** Server-computed badge visibility when present (preferred — avoids client clock skew). */
  isNew?: boolean;
  newFlag?: boolean;
  newFlagExpiresAt?: string | null;
}

/**
 * True when the storefront "New" badge should render.
 * Prefers API `isNew` when provided; otherwise `newFlag && (expires == null || now < expires)`.
 */
export function isProductNew(product?: ProductNewFields | null): boolean {
  if (!product) {
    return false;
  }
  if (typeof product.isNew === 'boolean') {
    return product.isNew;
  }
  if (!product.newFlag) {
    return false;
  }
  if (!product.newFlagExpiresAt) {
    return true;
  }
  const expiresAt = new Date(product.newFlagExpiresAt).getTime();
  return Number.isNaN(expiresAt) || expiresAt > Date.now();
}
